import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../pages/home/home.vue';
import Login from '../pages/login/show.vue';
import Send from '../pages/send/show.vue';
import Follow from '../pages/follow/show.vue';
import Users from '../pages/users/index/index.vue';
import Societes from '../pages/societes/Societes.vue';
import User from '../pages/users/show/show.vue';
import Contact from '../pages/contact/contact.vue';
import store from '../store'

const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/se-connecter',
    component: Login,
  },
  {
    path: '/utilisateurs',
    component: Users,
    meta: {
      requiresAuth: true,
      canAccess: 'access users'
    },
  },
  {
    path: '/societes',
    component: Societes,
    meta: {
      requiresAuth: true,
      canAccess: 'edit users'
    },
  },
  {
    path: '/mon-compte',
    component: User,
  },
  {
    path: '/envoyer-courrier',
    component: Send,
    meta: {
      requiresAuth: true,
      canAccess: 'create orders'
    },
  },
  {
    path: '/suivre-courrier',
    component: Follow,
    meta: {
      requiresAuth: true,
      canAccess: 'create orders'
    },
  },
  {
    path: '/contact',
    component: Contact,
    meta: {
      requiresAuth: true,
      canAccess: 'access users'
    },
  },
];


Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  history: true,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user is loggin
    if (window.$cookies.isKey("_token")) {
      // Get info about the user
      store.dispatch('getUser').then(res => {
        store.dispatch('getPermissions').then(res => {
          // s'il y a un accès spécial ici
          if (to.matched[0].meta.canAccess) {
            // si le user a accès
            if(store.getters.auth.permissions.find(perm => perm.name == to.matched[0].meta.canAccess)) {
              next()
            } else {
              // s'il n'a pas accès on regarde s'il est waiting approval
              next('/mon-compte')
            }
          } else {
            next();
          }
          return
        }).catch(err => {
          next('/se-connecter')
          return
        })
      }).catch(err => {
        next('/se-connecter')
        return
      })
    } else {
      next('/se-connecter')
    }
  } else {
    console.log('next');
    next()
  }
})

export default router;
